import ChooseCaptainMulti from '@/components/wasilni/input/ChooseCaptainMulti';
import ChoosePermissionsMulti from "@/components/wasilni/input/ChoosePermissionMulti";
import ChooseImage from "@/components/wasilni/input/ChooseImage";
import ChooseCars from "@/components/wasilni/input/ChooseCars";
import ChooseRole from "@/components/wasilni/input/ChooseRole";
import ChooseGender from "@/components/wasilni/input/ChooseGender";
import ChooseDate from "@/components/wasilni/input/ChooseDate";
import ChooseVoucher from "@/components/wasilni/input/ChooseVoucher";
import ChooseTime from "@/components/wasilni/input/ChooseTime";
import ChooseNumbers from "@/components/wasilni/input/ChooseNumbers";
import ChooseBeeslineAreaCluster from "@/components/wasilni/input/ChooseBeeslineAreaCluster";
import ChooseAppearanceConstrain from "@/components/wasilni/input/ChooseAppearanceConstrain";
import ChooseLocationMulti from "@/components/wasilni/input/ChooseLocationMulti";
import ChooseProject from "@/components/wasilni/input/ChooseProject";
import {VSelect} from "vuetify/lib/components/VSelect";
import ChooseLevel from "@/components/wasilni/input/ChooseLevel";
import { VTextField } from 'vuetify/lib/components'

export default {
    "choose-captains-multi": ChooseCaptainMulti,
    'choose-permissions-multi': ChoosePermissionsMulti,
    'choose-image-single': ChooseImage,
    'choose-cars': ChooseCars,
    'choose-role': ChooseRole,
    'choose-gender': ChooseGender,
    'choose-date': ChooseDate,
    'choose-voucher': ChooseVoucher,
    'choose-time': ChooseTime,
    'choose-numbers': ChooseNumbers,
    'choose-beesline-area-cluster': ChooseBeeslineAreaCluster,
    'choose-appearance-constrain' : ChooseAppearanceConstrain,
    'choose-locations' : ChooseLocationMulti,
    'choose-project': ChooseProject,
    'choose-level': ChooseLevel,
    "v-select" : VSelect,
    "v-text-field" : VTextField
};

